<app-modal-dialog title="Change stakeholder" (dismiss)="cancel()">
    <main>
        <app-singleselectbox decorator name="stakeholder" caption="Choose stakeholder" [dataSource]="stakeholders()" [(ngModel)]="newSelectedStakeholderId" [autoSort]="true" displayExpr="Name"
            valueExpr="StakeholdersId"></app-singleselectbox>
        <app-control-label [control]="null" caption="Please enter a comment"></app-control-label>
        <textarea class="form-control" rows="5" [(ngModel)]="comment"></textarea>
    </main>
    <footer>
        <div class="button-container">
            <app-button primary width="100%" [disabled]="selectedStakeholderId() === newSelectedStakeholderId()" (buttonClick)="ok()">Ok</app-button>
            <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
        </div>
    </footer>
</app-modal-dialog>
